<template>
  <div class="car-add">
	  
	<div class="headCarAdd">
	  	<i class="el-icon-setting"></i>&nbsp;&nbsp;安装包上传管理
	</div>
   
    <div class="filter-container" style="padding-top: 15px;width: 100%;align: center;"  border highlight-current-row>
		<!-- <label class="col-sm-2 control-label">安装包信息：</label> -->
		<el-form :model="uploadData">
			<el-form-item label="APP类型" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-select v-model="uploadData.verAppSel" placeholder="请选择APP类型">
			      <el-option v-for="(value,index) in verAppSelOptions" :key="index" :value="value"
						@click.native="verAppSelHandle(index)">
			      </el-option>
			    </el-select>
			  </el-col>
			</el-form-item>
			<el-form-item label="版本类型" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-select v-model="uploadData.verSel" placeholder="请选择版本类型">
			      <el-option v-for="(value,index) in verSelOptions" :key="index" :value="value"
						 @click.native="verSelHandle(index)">
			      </el-option>
			    </el-select>
			  </el-col>
			</el-form-item>
			<el-form-item label="版本日期" label-width="120px" style="width: 180%;">
				<el-date-picker v-model="uploadData.verTime" type="date" 
					placeholder="请选择日期" value-format="yyyyMMdd">
				</el-date-picker>
			</el-form-item>		
			<el-form-item label="版本名称" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-input :value="uploadData.verName" maxlength="20"
				  @input="e => uploadData.verName = e.replace(/[^\d^\.]+/g,'')"
			      placeholder="请输入APK版本名称(如：2.3.0)">
			    </el-input> 
			  </el-col>
			</el-form-item>
			<el-form-item label="版本号" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-input :value="uploadData.verNum"
			      @input="e => uploadData.verNum = e.replace(/[^\d]/g,'')" maxlength="20"
			      placeholder="请输入APK版本号">
			    </el-input> 
				<label style="color: rgb(255, 84, 17);">只能输入数字</label>
			  </el-col>
			</el-form-item>
			<!-- <el-form-item label="名称" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-input :value="uploadData.verName"
			      @input="e => uploadData.verName = e.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]+$/g,'')" maxlength="20"
			      placeholder="techinaoapp.apk">
			    </el-input> 
				<label style="color: rgb(255, 84, 17);">只能输入techinaoapp.apk</label>
			  </el-col>
			</el-form-item> -->
			<!-- <el-form-item label="下载地址" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-input
			      v-model="uploadData.verUrl" 
			      placeholder="请输入APK下载地址"> 
			    </el-input> 
				<label style="color: rgb(255, 84, 17);">网址必须是"http://"格式</label>
			  </el-col>
			</el-form-item> -->
			<el-form-item label="描述信息" label-width="120px" style="width: 180%;">
			  <el-col :span="12">
			    <el-input :value="uploadData.verInfo"
			      @input="e => uploadData.verInfo = e.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]+$/g,'')" maxlength="20"
			      placeholder="请输入APK描述信息">
			    </el-input> 
			  </el-col>
			</el-form-item>
		</el-form>
	</div>
   
	<div class="portlet-body flip-scroll" style="padding-bottom:50px;">	
		<!-- justify-content: center;主轴居中     align-items: center;"侧轴居中 -->
		<el-row :gutter="20" style="display: flex;align-items: center;margin-left: 10px;">
		  <el-col :span="1.5" >
			  <div class="grid-content bg-purple;">
			    <label >添加安装包:</label>
			  </div>
		  </el-col>
		  <el-col :span="4" style="padding-left:0px;"><div class="grid-content bg-purple" >
		  <!-- 文件上传区 --> <!-- upData -->
		  <el-upload
		    :multiple="false"
		    class="upload-demo"
		    ref="upload"
		    name="mfile"
		    :action="url"
		    :headers="uploadHeaders"
		    :data="uploadData" 
		    :on-preview="handlePreview"
		    :on-remove="handleRemove"
		    :before-remove="beforeRemove"
		    :limit="1"
		    :on-success="successUpload"
		    :on-error="errorUpload"
		    accept=".apk"
		    :file-list="file_list"
		    :auto-upload="false">
		    <el-button slot="trigger" type="warning">选择文件</el-button>
		    <el-button style="margin-left: 10px;"  type="success" @click="add(uploadData)">上传</el-button> <!-- submitUpload() add(formVersionData) -->
		  </el-upload>
		  </div></el-col>
		  <el-col :span="1.5"  style="padding-top: 12px;">
				<div class="grid-content bg-purple;">
		  			 <label style="color: rgb(255, 84, 17);">限.apk文件</label>
		  		</div>
		  </el-col>
		  <el-col :span="13"><div class="grid-content bg-purple"></div></el-col>
		</el-row>
    </div>
  </div>
</template>

<script>
	
export default {
  name: 'APKAdd',
  data(){
  	  return{
		  // formVersionData:{
		  // 	verNum:'',
		  // 	verName:'',
		  // 	verUrl:'',
		  // 	verInfo:'',
		  // },
  		 apkName:'',
		 //文件上传
		 file_list:[],
		 uploadHeaders:{authorization:this.$store.state.user.authorization},
		 uploadData:{
		     command_id:80,
			 verNum:'',
			 verName:'', //techinaoapp.apk
			 verUrl : '', //http://123.techinao.com/apk/techinaoapp.apk
			 verInfo:'',
			 verTime: '',
			 verSel:'', 
			 verAppSel:'',
			 verplatform:'0'
		 },
		 verSelOptions:[
			 '最新版本',
			 '历史版本'
		 ],
		 verAppSelOptions:[
			 '用户版本',
			 '管理员版本'
		 ],
		 url:process.env.VUE_APP_BASE_API+'/apk/add_apk',
		 error_input: false,
  	  };//
  },
  // computed: {
  //      // 这里定义上传文件时携带的参数，即表单数据
  //       upData: function() {
  //         return {
  //           body: JSON.stringify(this.formVersionData);
  //         }
  //       }
  //  },
  methods:{
	  /**
	   * 上传文件处理
	   */
	  handleRemove(file, fileList) {
	    console.log(file, fileList);
	  },
	  handlePreview(file) {
	    console.log(file);
	  },
	  beforeRemove(file, fileList) {
	    return this.$confirm(`确定移除 ${ file.name }？`);
	  },
		/**
		 * 上传成功
		 * @param {Object} res
		 * @param {Object} file
		 * @param {Object} fileList
		 */
		successUpload(res, file, fileList){
		    if(res.result==="0"){
		        this.$message({
		            message: res.message,
		            type: 'success'
		        })			
		    }else{
		        this.$message.error(res.message);	
		    }
			this.$refs.upload.clearFiles();//上传成功清除列表，否则每次上传都要删掉上次上传的列表
			this.clear_input();
		},
		/**
		 * 上传发生错误
		 * @param {Object} err
		 * @param {Object} file
		 * @param {Object} fileList
		 */
		errorUpload(err, file, fileList){
		    this.$message.error('上传失败'+err.message);
		},
		/**
		 * 提交上传文件
		 */
		submitUpload(){
		    this.$refs.upload.submit();  
			
		},
		/**
		 * 提交上传文件
		 */
		add(form) {
			this.check_input()		
			if(!this.error_input){
				this.$refs.upload.submit(); // 原始提交事件	
			}
			
		},
		verSelHandle(index){
			if(this.uploadData.verAppSel === ''){
				this.$alert('请先选择APP类型')
				return
			}
			// if(this.uploadData.verAppSel === '管理员版本' && index === 0){ //管理员最新版本  verNum=1
			// 	this.uploadData.verNum = '1'
			// }else if(this.uploadData.verAppSel === '用户版本' && index === 0){ //用户最新版本  verNum=2
			// 	this.uploadData.verNum = '2'
			// }
		},
		verAppSelHandle(index){
			if(this.uploadData.verAppSel === '管理员版本'){
				// this.uploadData.verName = 'techinaoapp.apk';
				this.uploadData.verUrl = 'http://123.techinao.com/apk/techinaoapp.apk';
			}else if(this.uploadData.verAppSel === '用户版本'){
				// this.uploadData.verName = 'techinaouser.apk';
				this.uploadData.verUrl = 'http://123.techinao.com/apk/techinaouser.apk';
			}
		},
		
		/**
		 * 校验input
		 */
		check_input(){
			 this.error_input = false;	 
			 if(this.uploadData.verAppSel === ''){
				 this.$alert('请选择APP类型')
				 this.error_input = true
				 return
			 }
			 if(this.uploadData.verSel === ''){
			 	this.$alert('请选择版本类型')
			 	this.error_input = true
			 	return
			 }
			 if(this.uploadData.verTime === ''){
			 	this.$alert('请选择日期')
			 	this.error_input = true
			 	return
			 }
			 if (this.uploadData.verNum === '') {
			   this.$alert('请输入版本号')
			   this.error_input = true
			   return
			 }
			 let d = /^[0-9]*$/ ;
			 if (!d.test(this.uploadData.verNum)) {
			   this.$alert('版本号只能是数字！')
			   this.error_input = true
			   return
			 }
			 
			 // let n = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|www\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
			 let n = /(http|https):\/\/([\w.]+\/?)\S*/　;
			 if (!n.test(this.uploadData.verUrl)) {
			   this.$alert('网址不正确！')
			   this.error_input = true
			   return
			 }
			 if (this.uploadData.verInfo === '') {
			   this.$alert('请输入描述信息')
			   this.error_input = true
			   return
			 }
		},
		
		clear_input(){
			this.uploadData.verAppSel = ''
			this.uploadData.verNum = ''
			this.uploadData.verName == ''
			this.uploadData.verUrl == ''
			this.uploadData.verInfo = ''
			this.uploadData.verSel = ''
			this.uploadData.verTime = ''
		},
	  
  }
}
</script>

<style>
.headCarAdd{
		background-color:#3fb976;
		width:100%;
		height:50px;
		color:#FFFFFF;
		line-height:50px;
		padding-left: 15px;
		border-radius: 10px;
	}
</style>
